/**
 * Доступные переменные окружения. Заинжекчены через webpack DefinePlugin
 * (см. webpack.config.js), поэтому всегда доступны как строки на runtime.
 */
export const env = {
    apiUrl: process.env.REACT_APP_API_URL ?? 'http://localhost:5002',
    frontendUrl: process.env.REACT_APP_FRONTEND_URL ?? 'http://localhost:5000'
} as const;
